import type { EnrichmentPlugin, Event } from '@amplitude/analytics-types';
import { SpecialEventType } from '@amplitude/analytics-types/lib/esm/event';

const SPECIAL_EVENT_TYPES: string[] = [
  SpecialEventType.IDENTIFY,
  SpecialEventType.GROUP_IDENTIFY,
  SpecialEventType.REVENUE,
] as const;

type GetDynamicProps = () => Record<string, unknown>;

type DefaultPropsPluginParams = {
  defaultProps: Record<string, unknown>;
  getDynamicProps?: GetDynamicProps;
};

export class DefaultPropsPlugin implements EnrichmentPlugin {
  name = 'default-props-plugin';
  private readonly defaultProps: Record<string, unknown>;
  private readonly getDynamicProps?: GetDynamicProps;

  constructor(params: DefaultPropsPluginParams) {
    this.defaultProps = params.defaultProps;
    this.getDynamicProps = params.getDynamicProps;
  }

  async execute(event: Event) {
    if (SPECIAL_EVENT_TYPES.includes(event.event_type)) {
      return event;
    }

    event.event_properties = {
      ...this.defaultProps,
      ...this.getDynamicProps?.(),
      ...event.event_properties,
    };

    return event;
  }
}
